import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';

import { buildGuards, hasFlagEnabled } from '@mint-lib/routing-guards';
import * as DataIngestion from '@mint-sdk/api-data-ingestion';
import { z } from 'zod';

const importHubV2Guard = buildGuards(hasFlagEnabled('importHubV2'));

const searchSchema = z.object({
  template: z.string().optional(),
});

export const Route = createFileRoute(
  '/_secured/external-data/import-hub/performance/imports/new',
)({
  validateSearch: searchSchema,
  async beforeLoad({ context }) {
    const hasModifyPermission = await context.hasPermission(
      'dataManagementHubFeature:modify',
    );
    if (!hasModifyPermission) {
      throw redirect({
        to: '/external-data/import-hub/performance/',
      });
    }
  },
  loaderDeps: ({ search: { template } }) => ({ template }),
  loader: async (opts) => {
    const { template } = opts.deps;

    const armGuardsContext = await opts.context.getGuardContext(
      await opts.context.getInstance('flagsmith', '@mint/arm'),
    );
    const isImportHubV2 = importHubV2Guard(armGuardsContext);

    try {
      const createDataFileEndpoint = isImportHubV2
        ? DataIngestion.DataFile.createDataFileV2
        : DataIngestion.DataFile.createDataFile;

      const { data } = await createDataFileEndpoint({
        data: {
          fromTemplateId: template ?? null,
          granularityLevel: 'media_row',
        },
      });
      throw redirect({
        to: '/external-data/import-hub/performance/imports/$dataFileId/upload',
        params: {
          dataFileId: data.additional.id,
        },
      });
    } catch (error: unknown) {
      if (isRedirect(error)) {
        throw error;
      }

      throw redirect({
        to: '/external-data/import-hub/performance/',
      });
    }
  },
});
